import React, { useState , useEffect } from 'react';
import NavbarHome from '../components/HomeComponents/NavbarHome';
import { Link, Navigate , useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';
import './CartPage.css';
import {   db    , collection , getDocs ,deleteDoc , doc } from '../firebase';


const CartPage = () => {

  let navigate = useNavigate();

  const [cartItems , setCartItems ] = useState([]);
  const [priceValue , setPriceValue ] = useState(0);

  const user = JSON.parse(localStorage.getItem("tourst_compass_user"));

  const totalPrice = (array) => {
    const prices = array.map((item) => parseInt(item.price));
    let totalValue  = prices.reduce((a, b) => a + b);
    setPriceValue(totalValue);
  };

  useEffect(() => {

    const getUsersOrders = async () => { 
      const querySnapshot = await getDocs(collection(db, `cart ${user.id}` ));
      const ordersDataArray = querySnapshot.docs
      .map((doc) => ({ ...doc.data(), id: doc.id }));

      totalPrice(ordersDataArray);

      setCartItems(ordersDataArray);
  
     
    }
    getUsersOrders();


} , [cartItems]);

const removeCartFromDb = async (id) => { 
 
  await deleteDoc(doc(db, `cart ${user.id}`, id ));

}


  return (
    <div className="main_homepage" >

    { !user ? <Navigate to="/" replace /> : ''  }

    
        <NavbarHome />
    
      
    
        <div className="section most_features_section container-sm">
    
    

      <div className="d-flex-c">
    
    <div className="info_box"></div>
    <h1 className="main_headline">    عربة التسوق </h1>
    </div>

    <div className="buyitems_div">
        <div className="grid_carts">
            <div className="g-col-2">

            <div>

            <div className="grid_tablecarts">
            {cartItems ? cartItems.map(({ id , name , price   , image , service_desc , service_provider }) => (
              <div className='single_package_item mt-3 w-100' >
    <img src={image} alt="" className="package_image" />
    <div className="mt-1-small"></div>
    <div className="body_package_card">

  <h1 className="location_slidetwo_headline mt-1"> {name} </h1>
  <div className="mt-1-small"></div>
<p className="main_para_small">  {service_desc} </p>

<div className="mt-1-small"></div>

<button className="btn_category w-100 bg_yellow">  مقدم الخدمة : {service_provider}   </button>

<button  className="w-100 mt-1 btn_pricing p-3"  > السعر : <span className="span_bold"> {price} </span> ريال</button> 

<button  className="mt-1 btn_pricing mx-2 bg_red w-100" onClick={() => removeCartFromDb(id) }  > ❌ الغاء   </button> 
  


    </div>

  </div>

                   )) : ''}
            </div>

                </div>

                <div>   
            <h3 className='main_headline' >المجموع</h3>
           <div className="panel_carts">

           {/* <div className="d-flex-c f-sp">
            <p className='para_table' > SAR {priceValue - taxValue}.00 </p> 
            <p className='para_table' > المجموع غير شامل الضريبة </p>
            </div> */}

          
{/* 
           <div className="d-flex-c f-sp">
           <p className="para_table">SAR {taxValue}.00</p>
           <p className="para_table"> ضريبة القيمة المضافة </p>
            </div> */}

           <div className="d-flex-c f-sp">
           <p className="main_para"> مجموع المنتجات شامل ضريبة القيمة المضافة </p>
           <p className="main_para ">SAR {priceValue  }.00</p> 
         
            </div>

           <div className="d-flex-c f-sp">
           <h4 className='main_para' >المجموع الكلي</h4>
         	<h4 className='main_para bg_green p-1' >SAR {priceValue }.00</h4>
        
            </div>


           </div>
           
                <div className='cart_btns mt-3' >
               <div>
               <Link to="/packages" >     
               <button className=" btn_shopping w-100">مواصلة التسوق</button>
               </Link>
               </div>
                <div>
                  
                <button className="btn_shopping w-100 bg_green" onClick={() => navigate('/confirm-order') } > حجز الطلب </button>
                
                </div>
                </div>
          
              
                </div>

                

            </div>
        </div>
    </div>


    
        </div>
    
    
        <Footer />
        </div>
  )
}

export default CartPage